import { IAppConfiguration } from '@nimbus-library/features/shared/services/base-http/app.configuration';

export const AppConfiguration: IAppConfiguration = {
  baseApiUrl: '/api/',
  licenseUrl: 'https://luware.com/en/privacy-policy/',
};
